import { Box } from '@material-ui/core';

import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';

interface ScoreCardProps {
  label: string | JSX.Element;
  value: string | number | JSX.Element;
}

export const ReportDetailsCard = ({ label, value }: ScoreCardProps) => {
  return (
    <Box display={'flex'} flexDirection={'row'}>
      <CustomDivider orientation="vertical" margin={0} />
      <Box pl={3} display={'flex'} flexDirection={'column'} justifyContent={'flex-start'}>
        <Font variant="h2" color={'title'} style={{ paddingBottom: '2px' }}>
          {value}
        </Font>
        <Font variant="caption" color={'textSecondary'}>
          {label}
        </Font>
      </Box>
    </Box>
  );
};
